import { render, staticRenderFns } from "./videoProjection.vue?vue&type=template&id=4a2754fd&scoped=true&"
import script from "./videoProjection.vue?vue&type=script&lang=js&"
export * from "./videoProjection.vue?vue&type=script&lang=js&"
import style0 from "./videoProjection.vue?vue&type=style&index=0&id=4a2754fd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2754fd",
  null
  
)

export default component.exports